# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/


$(document).on "turbolinks:load", ->
  $("#sso-popup").modal("show")
  $("#close-sso-popup-id").on 'click', ->
    $("#sso-popup").modal("hide")